import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'

export const List = ({ data }: { data: any }) => {
  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={8}
      slidesPerView={2}
      loop={false}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
      }}
      watchSlidesProgress={true}
      className="reviewSlider !overflow-visible mt-8"
    >
      {data?.items?.map((el: any, i: number) => (
        <SwiperSlide
          className="bg-boxBg rounded-button !h-[unset] min-h-full font-semibold mt-1 p-6  text-left text-white border-0 whitespace-normal"
          key={el.title + i}
        >
          {el.icon && <img className="mb-4" src={el.icon} alt={el.title} width={32} height={32} />}
          {el.title}
        </SwiperSlide>
      ))}
    </Swiper>
  )
}
